import React from "react";
import clsx from "clsx";
import { sanitizeHtml } from "../../lib/sanitizeHtml";
import styles from "./styles.module.css";

interface InnerHTMLProps {
  as?: keyof JSX.IntrinsicElements;
  html: string;
  className?: string;
  onClick?: () => void;
}

/**
 * Renders an HTML fragment that originates from user/agent-authored content.
 *
 * The markup is sanitized (see `sanitizeHtml`) before injection, so this component
 * is the shared, safe entry point for displaying stored rich text and should be
 * preferred over a direct `dangerouslySetInnerHTML`.
 */
export function InnerHTML({ as = "span", html, className, onClick }: InnerHTMLProps) {
  return React.createElement(as, {
    className: clsx("InnerHTML", className, styles.InnerHTML),
    dangerouslySetInnerHTML: { __html: sanitizeHtml(html) },
    onClick,
  });
}
